(() => {
  const sequenceMobileHeader = (root = document) => {
    const scope = root.querySelectorAll ? root : document;

    scope.querySelectorAll('#header .header-mobile .header-mobile_top').forEach((top) => {
      if (top.dataset.gbeSequenceReady === 'true') return;

      const logo = top.querySelector(':scope > .gbe-header-logo');
      const searchItem = top.querySelector('.header-icons .m-icon-search');
      if (!logo || !searchItem) return;

      const searchSlot = document.createElement('ul');
      searchSlot.className = 'gbe-mobile-search-slot';
      searchSlot.setAttribute('role', 'list');

      searchSlot.appendChild(searchItem);
      top.insertBefore(searchSlot, logo);
      top.dataset.gbeSequenceReady = 'true';
    });
  };

  const getFullLanguageName = (code) => {
    const normalized = String(code || '').trim().toLowerCase();
    if (!normalized) return '';

    const fallbacks = {
      en: 'English',
      hi: 'हिन्दी',
      ta: 'தமிழ்'
    };

    try {
      if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
        const locale = normalized.split('-')[0];
        const displayNames = new Intl.DisplayNames([locale], { type: 'language' });
        const name = displayNames.of(normalized);
        if (name) return name.charAt(0).toUpperCase() + name.slice(1);
      }
    } catch (error) {
      // Use the stable fallback below if the browser cannot resolve the locale name.
    }

    return fallbacks[normalized] || fallbacks[normalized.split('-')[0]] || normalized.toUpperCase();
  };

  const expandLanguageLabels = (root = document) => {
    const scope = root.querySelectorAll ? root : document;

    scope.querySelectorAll('#languages-select option, select[name="languages-select"] option').forEach((option) => {
      const currentLabel = (option.textContent || '').trim();
      const code = option.dataset.gbeLocaleCode || currentLabel;

      if (!option.dataset.gbeLocaleCode && /^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(code)) {
        option.dataset.gbeLocaleCode = code;
      }

      const localeCode = option.dataset.gbeLocaleCode;
      if (!localeCode) return;

      const fullName = getFullLanguageName(localeCode);
      if (fullName && option.textContent !== fullName) option.textContent = fullName;
    });
  };

  const refreshMobileHeader = (root = document) => {
    sequenceMobileHeader(root);
    expandLanguageLabels(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refreshMobileHeader(document), { once: true });
  } else {
    refreshMobileHeader(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    refreshMobileHeader(event.target || document);
  });

  const languageObserver = new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes && record.addedNodes.length)) {
      expandLanguageLabels(document);
    }
  });

  languageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
